import type { GiantId } from '../ids/ids';
import type { GiantItemsLayout } from './itemsLayout';

/** Три layout на гиганта: index = orderIndex (из `1.svg`/`2.svg`/`3.svg`). */
export type GiantItemsLayoutVariants = readonly [
  GiantItemsLayout,
  GiantItemsLayout,
  GiantItemsLayout,
];

/** Обновление: npm run extract:level-layouts */
export const GIANT_ITEMS_LAYOUT: Record<GiantId, GiantItemsLayoutVariants> = {
  drakochi: [
    {
      giantId: "drakochi",
      route: {
        viewBoxWidth: 6276,
        viewBoxHeight: 428,
        startPointSvgX: 64.270353,
        spawnSvgX: 72.805341,
        spawnSvgY: 208.872169,
        startLane: 0.511981,
        routeEndS: 5724.973535,
        finishCourierPlaceSvgX: 5794.389993,
        finishCourierPlaceSvgY: 208.872169,
        laneMin: 0.080645,
        laneMax: 0.741935
      },
      staticObstacles: [
        {
          id: "static",
          s: 618.373417,
          lane: 0.520096
        },
        {
          id: "static_2",
          s: 1107.287176,
          lane: 0.232999
        },
        {
          id: "static_3",
          s: 1440.648317,
          lane: 0.64251
        },
        {
          id: "static_4",
          s: 2180.684709,
          lane: 0.548434
        },
        {
          id: "static_5",
          s: 2656.202691,
          lane: 0.520096
        },
        {
          id: "static_7",
          s: 2914.945952,
          lane: 0.153315
        },
        {
          id: "static_6",
          s: 3171.283665,
          lane: 0.643752
        },
        {
          id: "static_8",
          s: 3430.807352,
          lane: 0.133912
        },
        {
          id: "static_11",
          s: 3884.684587,
          lane: 0.703967
        },
        {
          id: "static_10",
          s: 4074.282129,
          lane: 0.173859
        },
        {
          id: "static_9",
          s: 4311.164288,
          lane: 0.723322
        },
        {
          id: "static_12",
          s: 4669.650547,
          lane: 0.623695
        },
        {
          id: "static_13",
          s: 4820.502247,
          lane: 0.103337
        },
        {
          id: "static_14",
          s: 5167.929414,
          lane: 0.113921
        },
        {
          id: "static_15",
          s: 5334.619166,
          lane: 0.559017
        },
        {
          id: "static_16",
          s: 5483.955923,
          lane: 0.336763
        }
      ],
      movingObstacles: [],
      boosters: [
        {
          id: "shield",
          s: 342.47089,
          lane: 0.520096,
          type: "shield"
        },
        {
          id: "shield_2",
          s: 1924.897885,
          lane: 0.412569,
          type: "shield"
        },
        {
          id: "speed",
          s: 3390.26194,
          lane: 0.459881,
          type: "speed"
        },
        {
          id: "speed_2",
          s: 4619.657393,
          lane: 0.31687,
          type: "speed"
        }
      ],
      sparks: [
        {
          id: "small",
          s: 1476.042919,
          lane: 0.322653
        },
        {
          id: "small_2",
          s: 2401.416647,
          lane: 0.282462
        },
        {
          id: "small_3",
          s: 4176.65562,
          lane: 0.480311
        }
      ]
    },
    {
      giantId: "drakochi",
      route: {
        viewBoxWidth: 6276,
        viewBoxHeight: 428,
        startPointSvgX: 64.270353,
        spawnSvgX: 72.805341,
        spawnSvgY: 208.872169,
        startLane: 0.511981,
        routeEndS: 5724.973535,
        finishCourierPlaceSvgX: 5794.389993,
        finishCourierPlaceSvgY: 208.872169,
        laneMin: 0.078495,
        laneMax: 0.739785
      },
      staticObstacles: [
        {
          id: "static",
          s: 618.373417,
          lane: 0.520096
        },
        {
          id: "static_2",
          s: 1107.287176,
          lane: 0.232999
        },
        {
          id: "static_3",
          s: 1440.648317,
          lane: 0.64251
        },
        {
          id: "static_4",
          s: 2180.684709,
          lane: 0.548434
        },
        {
          id: "static_5",
          s: 2656.202691,
          lane: 0.520096
        },
        {
          id: "static_7",
          s: 2914.945952,
          lane: 0.153315
        },
        {
          id: "static_6",
          s: 3175.874404,
          lane: 0.480311
        },
        {
          id: "static_8",
          s: 3430.807352,
          lane: 0.133912
        },
        {
          id: "static_13",
          s: 3611.535585,
          lane: 0.548053
        },
        {
          id: "static_11",
          s: 3884.684587,
          lane: 0.703967
        },
        {
          id: "static_10",
          s: 4074.282129,
          lane: 0.173859
        },
        {
          id: "static_9",
          s: 4311.164288,
          lane: 0.723322
        },
        {
          id: "static_12",
          s: 4669.650547,
          lane: 0.623695
        },
        {
          id: "static_14",
          s: 4820.502247,
          lane: 0.103337
        },
        {
          id: "static_15",
          s: 5167.929414,
          lane: 0.113921
        },
        {
          id: "static_16",
          s: 5334.619166,
          lane: 0.559017
        },
        {
          id: "static_17",
          s: 5483.955923,
          lane: 0.336763
        }
      ],
      movingObstacles: [],
      boosters: [
        {
          id: "shield",
          s: 342.47089,
          lane: 0.520096,
          type: "shield"
        },
        {
          id: "shield_2",
          s: 1924.897885,
          lane: 0.412569,
          type: "shield"
        },
        {
          id: "speed",
          s: 3390.26194,
          lane: 0.459881,
          type: "speed"
        },
        {
          id: "speed_2",
          s: 4619.657393,
          lane: 0.31687,
          type: "speed"
        }
      ],
      sparks: [
        {
          id: "small",
          s: 1476.042919,
          lane: 0.322653
        },
        {
          id: "small_2",
          s: 2906.397995,
          lane: 0.480311
        },
        {
          id: "small_3",
          s: 4176.65562,
          lane: 0.480311
        }
      ]
    },
    {
      giantId: "drakochi",
      route: {
        viewBoxWidth: 6276,
        viewBoxHeight: 428,
        startPointSvgX: 64.270353,
        spawnSvgX: 72.805341,
        spawnSvgY: 208.872169,
        startLane: 0.511981,
        routeEndS: 5724.973535,
        finishCourierPlaceSvgX: 5794.389993,
        finishCourierPlaceSvgY: 208.872169,
        laneMin: 0.077419,
        laneMax: 0.73871
      },
      staticObstacles: [
        {
          id: "static",
          s: 558.693803,
          lane: 0.282462
        },
        {
          id: "static_2",
          s: 847.451319,
          lane: 0.663107
        },
        {
          id: "static_3",
          s: 1440.648317,
          lane: 0.64251
        },
        {
          id: "static_4",
          s: 2180.684709,
          lane: 0.548434
        },
        {
          id: "static_5",
          s: 2687.259043,
          lane: 0.135676
        },
        {
          id: "static_6",
          s: 2721.400373,
          lane: 0.84536
        },
        {
          id: "static_7",
          s: 2902.89526,
          lane: 0.805379
        },
        {
          id: "static_8",
          s: 2914.945952,
          lane: 0.153315
        },
        {
          id: "static_9",
          s: 3270.902713,
          lane: 0.84536
        },
        {
          id: "static_10",
          s: 3430.807352,
          lane: 0.133912
        },
        {
          id: "static_15",
          s: 3611.535585,
          lane: 0.548053
        },
        {
          id: "static_13",
          s: 3844.001453,
          lane: 0.188006
        },
        {
          id: "static_11",
          s: 3963.241321,
          lane: 0.840069
        },
        {
          id: "static_12",
          s: 4243.643691,
          lane: 0.155666
        },
        {
          id: "static_14",
          s: 4669.650547,
          lane: 0.623695
        },
        {
          id: "static_16",
          s: 4820.502247,
          lane: 0.103337
        },
        {
          id: "static_17",
          s: 5167.929414,
          lane: 0.113921
        },
        {
          id: "static_18",
          s: 5334.619166,
          lane: 0.559017
        },
        {
          id: "static_19",
          s: 5483.955923,
          lane: 0.336763
        }
      ],
      movingObstacles: [],
      boosters: [
        {
          id: "shield",
          s: 342.47089,
          lane: 0.520096,
          type: "shield"
        },
        {
          id: "shield_2",
          s: 1924.897885,
          lane: 0.636225,
          type: "shield"
        },
        {
          id: "speed",
          s: 3176.012127,
          lane: 0.258563,
          type: "speed"
        },
        {
          id: "speed_2",
          s: 4619.657393,
          lane: 0.31687,
          type: "speed"
        }
      ],
      sparks: [
        {
          id: "small",
          s: 1476.042919,
          lane: 0.322653
        },
        {
          id: "small_2",
          s: 2651.864442,
          lane: 0.528444
        },
        {
          id: "small_3",
          s: 4176.65562,
          lane: 0.480311
        }
      ]
    }
  ],
  duck: [
    {
      giantId: "duck",
      route: {
        viewBoxWidth: 6276,
        viewBoxHeight: 428,
        startPointSvgX: 64.270353,
        spawnSvgX: 72.805341,
        spawnSvgY: 208.871248,
        startLane: 0.511983,
        routeEndS: 5724.973535,
        finishCourierPlaceSvgX: 5794.389993,
        finishCourierPlaceSvgY: 208.871248,
        laneMin: 0.084946,
        laneMax: 0.746237
      },
      staticObstacles: [
        {
          id: "static_18",
          s: 527.288554,
          lane: 0.520016
        },
        {
          id: "static_17",
          s: 790.232342,
          lane: 0.807731
        },
        {
          id: "static",
          s: 1361.57742,
          lane: 0.246216
        },
        {
          id: "static_2",
          s: 1659.79645,
          lane: 0.370279
        },
        {
          id: "static_3",
          s: 2152.818921,
          lane: 0.520212
        },
        {
          id: "static_4",
          s: 2677.219096,
          lane: 0.835954
        },
        {
          id: "static_5",
          s: 2681.988874,
          lane: 0.10863
        },
        {
          id: "static_6",
          s: 2906.411767,
          lane: 0.822431
        },
        {
          id: "static_7",
          s: 3069.828321,
          lane: 0.128034
        },
        {
          id: "static_8",
          s: 3272.091714,
          lane: 0.782382
        },
        {
          id: "static_9",
          s: 3473.418596,
          lane: 0.782382
        },
        {
          id: "static_10",
          s: 3896.721506,
          lane: 0.136265
        },
        {
          id: "static_11",
          s: 4081.439092,
          lane: 0.729694
        },
        {
          id: "static_12",
          s: 4428.150103,
          lane: 0.506101
        },
        {
          id: "static_13",
          s: 4746.683156,
          lane: 0.225637
        },
        {
          id: "static_14",
          s: 4957.076748,
          lane: 0.818903
        },
        {
          id: "static_16",
          s: 5270.624257,
          lane: 0.116862
        },
        {
          id: "static_15",
          s: 5371.253268,
          lane: 0.7995
        }
      ],
      movingObstacles: [],
      boosters: [
        {
          id: "speed",
          s: 301.42417,
          lane: 0.520016,
          type: "speed"
        },
        {
          id: "shield",
          s: 2480.414093,
          lane: 0.240925,
          type: "shield"
        },
        {
          id: "speed_2",
          s: 3699.489564,
          lane: 0.466253,
          type: "speed"
        },
        {
          id: "shield_2",
          s: 4345.310209,
          lane: 0.824196,
          type: "shield"
        }
      ],
      sparks: [
        {
          id: "small",
          s: 966.622326,
          lane: 0.370554
        },
        {
          id: "small_2",
          s: 1668.087325,
          lane: 0.668403
        },
        {
          id: "small_3",
          s: 2897.946443,
          lane: 0.466253
        },
        {
          id: "small_4",
          s: 4922.462572,
          lane: 0.485608
        }
      ]
    },
    {
      giantId: "duck",
      route: {
        viewBoxWidth: 6276,
        viewBoxHeight: 428,
        startPointSvgX: 64.270353,
        spawnSvgX: 72.805341,
        spawnSvgY: 208.871248,
        startLane: 0.511983,
        routeEndS: 5724.973535,
        finishCourierPlaceSvgX: 5794.389993,
        finishCourierPlaceSvgY: 208.871248,
        laneMin: 0.083871,
        laneMax: 0.745161
      },
      staticObstacles: [
        {
          id: "static_16",
          s: 293.160838,
          lane: 0.711414
        },
        {
          id: "static_15",
          s: 771.974971,
          lane: 0.174855
        },
        {
          id: "static",
          s: 1203.045412,
          lane: 0.59421
        },
        {
          id: "static_2",
          s: 1659.823994,
          lane: 0.19421
        },
        {
          id: "static_3",
          s: 2116.143503,
          lane: 0.79636
        },
        {
          id: "static_4",
          s: 2677.219096,
          lane: 0.835954
        },
        {
          id: "static_5",
          s: 2681.988874,
          lane: 0.10863
        },
        {
          id: "static_6",
          s: 2906.411767,
          lane: 0.822431
        },
        {
          id: "static_7",
          s: 3069.828321,
          lane: 0.128034
        },
        {
          id: "static_8",
          s: 3401.550569,
          lane: 0.426468
        },
        {
          id: "static_9",
          s: 3962.538938,
          lane: 0.466253
        },
        {
          id: "static_10",
          s: 4428.150103,
          lane: 0.506101
        },
        {
          id: "static_11",
          s: 4746.683156,
          lane: 0.225637
        },
        {
          id: "static_12",
          s: 4957.076748,
          lane: 0.818903
        },
        {
          id: "static_14",
          s: 5270.624257,
          lane: 0.116862
        },
        {
          id: "static_13",
          s: 5371.253268,
          lane: 0.7995
        }
      ],
      movingObstacles: [],
      boosters: [
        {
          id: "speed",
          s: 780.238302,
          lane: 0.730769,
          type: "speed"
        },
        {
          id: "shield",
          s: 2602.302818,
          lane: 0.457651,
          type: "shield"
        },
        {
          id: "speed_2",
          s: 3699.489564,
          lane: 0.466253,
          type: "speed"
        }
      ],
      sparks: [
        {
          id: "small",
          s: 1993.570757,
          lane: 0.438296
        },
        {
          id: "small_2",
          s: 3218.380062,
          lane: 0.782382
        },
        {
          id: "small_3",
          s: 4922.462572,
          lane: 0.485608
        }
      ]
    },
    {
      giantId: "duck",
      route: {
        viewBoxWidth: 6276,
        viewBoxHeight: 428,
        startPointSvgX: 64.270353,
        spawnSvgX: 72.805341,
        spawnSvgY: 208.871248,
        startLane: 0.511983,
        routeEndS: 5724.973535,
        finishCourierPlaceSvgX: 5794.389993,
        finishCourierPlaceSvgY: 208.871248,
        laneMin: 0.083871,
        laneMax: 0.745161
      },
      staticObstacles: [
        {
          id: "static_25",
          s: 217.87271,
          lane: 0.570186
        },
        {
          id: "static_29",
          s: 460.130626,
          lane: 0.303838
        },
        {
          id: "static_27",
          s: 572.075809,
          lane: 0.628396
        },
        {
          id: "static_26",
          s: 588.157169,
          lane: 0.151552
        },
        {
          id: "static_28",
          s: 765.116406,
          lane: 0.531968
        },
        {
          id: "static_2",
          s: 1124.089283,
          lane: 0.614872
        },
        {
          id: "static",
          s: 1361.57742,
          lane: 0.246216
        },
        {
          id: "static_3",
          s: 1539.087545,
          lane: 0.634848
        },
        {
          id: "static_4",
          s: 1659.80104,
          lane: 0.370279
        },
        {
          id: "static_5",
          s: 1872.834308,
          lane: 0.175708
        },
        {
          id: "static_6",
          s: 2152.818921,
          lane: 0.520212
        },
        {
          id: "static_15",
          s: 2408.57361,
          lane: 0.200439
        },
        {
          id: "static_7",
          s: 2663.818727,
          lane: 0.624095
        },
        {
          id: "static_8",
          s: 2677.131872,
          lane: 0.175708
        },
        {
          id: "static_9",
          s: 2893.011398,
          lane: 0.610571
        },
        {
          id: "static_10",
          s: 3091.216577,
          lane: 0.181084
        },
        {
          id: "static_11",
          s: 3099.452364,
          lane: 0.512568
        },
        {
          id: "static_12",
          s: 3379.661923,
          lane: 0.603665
        },
        {
          id: "static_13",
          s: 3580.984214,
          lane: 0.240296
        },
        {
          id: "static_14",
          s: 3580.984214,
          lane: 0.603665
        },
        {
          id: "static_23",
          s: 3840.549217,
          lane: 0.528403
        },
        {
          id: "static_16",
          s: 3896.716915,
          lane: 0.136265
        },
        {
          id: "static_17",
          s: 4098.424828,
          lane: 0.544525
        },
        {
          id: "static_18",
          s: 4428.150103,
          lane: 0.506101
        },
        {
          id: "static_19",
          s: 4746.683156,
          lane: 0.225637
        },
        {
          id: "static_20",
          s: 4998.668848,
          lane: 0.603665
        },
        {
          id: "static_24",
          s: 5090.024565,
          lane: 0.156353
        },
        {
          id: "static_21",
          s: 5237.479118,
          lane: 0.492577
        },
        {
          id: "static_22",
          s: 5412.845368,
          lane: 0.584262
        }
      ],
      movingObstacles: [],
      boosters: [
        {
          id: "speed",
          s: 207.593585,
          lane: 0.216819,
          type: "speed"
        },
        {
          id: "shield",
          s: 2508.651732,
          lane: 0.496138,
          type: "shield"
        },
        {
          id: "shield_2",
          s: 3254.646904,
          lane: 0.574267,
          type: "shield"
        },
        {
          id: "shield_3",
          s: 4256.571214,
          lane: 0.439866,
          type: "shield"
        }
      ],
      sparks: [
        {
          id: "small",
          s: 883.070867,
          lane: 0.28431
        },
        {
          id: "small_2",
          s: 1132.348023,
          lane: 0.324095
        },
        {
          id: "small_3",
          s: 1431.66424,
          lane: 0.476783
        },
        {
          id: "small_4",
          s: 1911.39652,
          lane: 0.590762
        },
        {
          id: "small_5",
          s: 2256.620132,
          lane: 0.200439
        },
        {
          id: "small_6",
          s: 2884.174224,
          lane: 0.324095
        },
        {
          id: "small_7",
          s: 4532.249713,
          lane: 0.240224
        },
        {
          id: "small_8",
          s: 4841.206483,
          lane: 0.524095
        }
      ]
    }
  ],
  factor: [
    {
      giantId: "factor",
      route: {
        viewBoxWidth: 6276,
        viewBoxHeight: 428,
        startPointSvgX: 64.270353,
        spawnSvgX: 72.805341,
        spawnSvgY: 208.873089,
        startLane: 0.511979,
        routeEndS: 5724.973535,
        finishCourierPlaceSvgX: 5794.389993,
        finishCourierPlaceSvgY: 208.873089,
        laneMin: 0.083871,
        laneMax: 0.745161
      },
      staticObstacles: [
        {
          id: "static",
          s: 820.365956,
          lane: 0.281748
        },
        {
          id: "static_2",
          s: 1213.333259,
          lane: 0.670995
        },
        {
          id: "static_3",
          s: 1819.021659,
          lane: 0.560449
        },
        {
          id: "static_4",
          s: 2165.452636,
          lane: 0.265619
        },
        {
          id: "static_5",
          s: 2683.747128,
          lane: 0.765619
        },
        {
          id: "static_6",
          s: 3200.86639,
          lane: 0.173895
        },
        {
          id: "static_7",
          s: 3282.453013,
          lane: 0.749743
        },
        {
          id: "static_8",
          s: 4102.565675,
          lane: 0.815377
        },
        {
          id: "static_9",
          s: 4144.988699,
          lane: 0.116862
        },
        {
          id: "static_10",
          s: 4444.965982,
          lane: 0.830663
        },
        {
          id: "static_11",
          s: 4906.854058,
          lane: 0.182715
        },
        {
          id: "static_12",
          s: 4941.514141,
          lane: 0.777158
        },
        {
          id: "static_13",
          s: 5414.957108,
          lane: 0.186831
        },
        {
          id: "static_14",
          s: 5515.586118,
          lane: 0.814788
        }
      ],
      movingObstacles: [],
      boosters: [
        {
          id: "shield",
          s: 520.131591,
          lane: 0.603253,
          type: "shield"
        },
        {
          id: "speed",
          s: 2966.536682,
          lane: 0.501102,
          type: "speed"
        },
        {
          id: "shield_2",
          s: 3831.450371,
          lane: 0.211526,
          type: "shield"
        },
        {
          id: "speed_2",
          s: 4682.091451,
          lane: 0.480672,
          type: "speed"
        }
      ],
      sparks: [
        {
          id: "small",
          s: 1447.920048,
          lane: 0.321533
        },
        {
          id: "small_2",
          s: 2495.985881,
          lane: 0.520457
        },
        {
          id: "small_3",
          s: 3435.710261,
          lane: 0.265619
        }
      ]
    },
    {
      giantId: "factor",
      route: {
        viewBoxWidth: 6276,
        viewBoxHeight: 428,
        startPointSvgX: 64.270353,
        spawnSvgX: 72.805341,
        spawnSvgY: 208.873089,
        startLane: 0.511979,
        routeEndS: 5724.973535,
        finishCourierPlaceSvgX: 5794.389993,
        finishCourierPlaceSvgY: 208.873089,
        laneMin: 0.08172,
        laneMax: 0.743011
      },
      staticObstacles: [
        {
          id: "static",
          s: 304.826826,
          lane: 0.341963
        },
        {
          id: "static_2",
          s: 820.365956,
          lane: 0.281748
        },
        {
          id: "static_3",
          s: 1213.333259,
          lane: 0.670995
        },
        {
          id: "static_4",
          s: 1819.021659,
          lane: 0.560449
        },
        {
          id: "static_5",
          s: 2188.286974,
          lane: 0.748012
        },
        {
          id: "static_7",
          s: 2683.747128,
          lane: 0.765619
        },
        {
          id: "static_6",
          s: 2711.612917,
          lane: 0.177424
        },
        {
          id: "static_8",
          s: 3200.86639,
          lane: 0.173895
        },
        {
          id: "static_9",
          s: 3282.453013,
          lane: 0.749743
        },
        {
          id: "static_10",
          s: 4102.565675,
          lane: 0.815377
        },
        {
          id: "static_11",
          s: 4144.988699,
          lane: 0.116862
        },
        {
          id: "static_12",
          s: 4444.965982,
          lane: 0.830663
        },
        {
          id: "static_13",
          s: 4906.854058,
          lane: 0.182715
        },
        {
          id: "static_14",
          s: 4941.514141,
          lane: 0.777158
        },
        {
          id: "static_15",
          s: 5414.957108,
          lane: 0.186831
        },
        {
          id: "static_16",
          s: 5515.586118,
          lane: 0.814788
        }
      ],
      movingObstacles: [],
      boosters: [
        {
          id: "shield",
          s: 520.131591,
          lane: 0.603253,
          type: "shield"
        },
        {
          id: "speed",
          s: 2966.536682,
          lane: 0.501102,
          type: "speed"
        },
        {
          id: "shield_2",
          s: 3831.450371,
          lane: 0.211526,
          type: "shield"
        },
        {
          id: "speed_2",
          s: 4682.091451,
          lane: 0.480672,
          type: "speed"
        }
      ],
      sparks: [
        {
          id: "small",
          s: 1447.920048,
          lane: 0.321533
        },
        {
          id: "small_2",
          s: 2495.985881,
          lane: 0.520457
        },
        {
          id: "small_3",
          s: 3435.710261,
          lane: 0.265619
        }
      ]
    },
    {
      giantId: "factor",
      route: {
        viewBoxWidth: 6276,
        viewBoxHeight: 428,
        startPointSvgX: 64.270353,
        spawnSvgX: 72.805341,
        spawnSvgY: 208.873089,
        startLane: 0.511979,
        routeEndS: 5724.973535,
        finishCourierPlaceSvgX: 5794.389993,
        finishCourierPlaceSvgY: 208.873089,
        laneMin: 0.080645,
        laneMax: 0.741935
      },
      staticObstacles: [
        {
          id: "static",
          s: 304.826826,
          lane: 0.341963
        },
        {
          id: "static_2",
          s: 718.451539,
          lane: 0.733123
        },
        {
          id: "static_4",
          s: 801.029761,
          lane: 0.139206
        },
        {
          id: "static_5",
          s: 1000.093408,
          lane: 0.563136
        },
        {
          id: "static_3",
          s: 1266.007404,
          lane: 0.752715
        },
        {
          id: "static_6",
          s: 1456.284376,
          lane: 0.728021
        },
        {
          id: "static_7",
          s: 1819.021659,
          lane: 0.560449
        },
        {
          id: "static_9",
          s: 2188.286974,
          lane: 0.748012
        },
        {
          id: "static_8",
          s: 2327.285385,
          lane: 0.131562
        },
        {
          id: "static_11",
          s: 2683.747128,
          lane: 0.765619
        },
        {
          id: "static_10",
          s: 2711.612917,
          lane: 0.177424
        },
        {
          id: "static_12",
          s: 3200.86639,
          lane: 0.173895
        },
        {
          id: "static_13",
          s: 3282.453013,
          lane: 0.749743
        },
        {
          id: "static_14",
          s: 3469.47056,
          lane: 0.587829
        },
        {
          id: "static_15",
          s: 4102.565675,
          lane: 0.815377
        },
        {
          id: "static_16",
          s: 4144.988699,
          lane: 0.116862
        },
        {
          id: "static_17",
          s: 4444.965982,
          lane: 0.830663
        },
        {
          id: "static_18",
          s: 4624.707207,
          lane: 0.607821
        },
        {
          id: "static_19",
          s: 4906.854058,
          lane: 0.182715
        },
        {
          id: "static_20",
          s: 4941.514141,
          lane: 0.777158
        },
        {
          id: "static_21",
          s: 5414.957108,
          lane: 0.186831
        },
        {
          id: "static_22",
          s: 5515.586118,
          lane: 0.814788
        }
      ],
      movingObstacles: [],
      boosters: [
        {
          id: "shield",
          s: 520.131591,
          lane: 0.603253,
          type: "shield"
        },
        {
          id: "shield_2",
          s: 2930.508558,
          lane: 0.690356,
          type: "shield"
        },
        {
          id: "speed",
          s: 3831.450371,
          lane: 0.211526,
          type: "speed"
        },
        {
          id: "speed_2",
          s: 4744.938675,
          lane: 0.225637,
          type: "speed"
        }
      ],
      sparks: [
        {
          id: "small",
          s: 1657.790296,
          lane: 0.322062
        },
        {
          id: "small_2",
          s: 2495.985881,
          lane: 0.520457
        },
        {
          id: "small_3",
          s: 3435.710261,
          lane: 0.265619
        }
      ]
    }
  ],
  mona: [
    {
      giantId: "mona",
      route: {
        viewBoxWidth: 6276,
        viewBoxHeight: 428,
        startPointSvgX: 64.270353,
        spawnSvgX: 72.805341,
        spawnSvgY: 208.870328,
        startLane: 0.511985,
        routeEndS: 5724.973535,
        finishCourierPlaceSvgX: 5794.389993,
        finishCourierPlaceSvgY: 208.870328,
        laneMin: 0.083871,
        laneMax: 0.745161
      },
      staticObstacles: [
        {
          id: "static_4",
          s: 633.839618,
          lane: 0.72517
        },
        {
          id: "static_7",
          s: 1811.919785,
          lane: 0.72517
        },
        {
          id: "static_9",
          s: 2544.64772,
          lane: 0.72517
        },
        {
          id: "static_10",
          s: 2905.153904,
          lane: 0.667209
        },
        {
          id: "static_13",
          s: 3276.930354,
          lane: 0.556082
        },
        {
          id: "static_14",
          s: 3500.095383,
          lane: 0.72517
        },
        {
          id: "static_17",
          s: 4017.967527,
          lane: 0.72517
        },
        {
          id: "static_19",
          s: 4320.203454,
          lane: 0.660741
        },
        {
          id: "static_22",
          s: 4603.360268,
          lane: 0.72517
        },
        {
          id: "static_26",
          s: 5258.550612,
          lane: 0.72517
        },
        {
          id: "static_27",
          s: 5607.72226,
          lane: 0.72517
        }
      ],
      movingObstacles: [
        {
          id: "static",
          s: 325.296015,
          lane: 0.499364
        },
        {
          id: "static_3",
          s: 834.409028,
          lane: 0.499364
        },
        {
          id: "static_6",
          s: 1264.561321,
          lane: 0.499364
        },
        {
          id: "static_8",
          s: 1708.944907,
          lane: 0.499364
        },
        {
          id: "static_11",
          s: 2120.734242,
          lane: 0.499364
        },
        {
          id: "static_12",
          s: 2661.523358,
          lane: 0.499364
        },
        {
          id: "static_18",
          s: 3195.885438,
          lane: 0.499364
        },
        {
          id: "static_20",
          s: 3763.672693,
          lane: 0.499364
        },
        {
          id: "static_23",
          s: 4417.022151,
          lane: 0.499364
        },
        {
          id: "static_25",
          s: 4856.355923,
          lane: 0.499364
        }
      ],
      boosters: [
        {
          id: "shield",
          s: 281.647723,
          lane: 0.622523,
          type: "shield"
        },
        {
          id: "shield_2",
          s: 1911.125666,
          lane: 0.270084,
          type: "shield"
        },
        {
          id: "shield_3",
          s: 3765.430946,
          lane: 0.72517,
          type: "shield"
        }
      ],
      sparks: [
        {
          id: "small_2",
          s: 976.997398,
          lane: 0.72517
        },
        {
          id: "small",
          s: 2750.771925,
          lane: 0.352644
        },
        {
          id: "small_3",
          s: 4744.938675,
          lane: 0.612528
        }
      ]
    },
    {
      giantId: "mona",
      route: {
        viewBoxWidth: 6276,
        viewBoxHeight: 428,
        startPointSvgX: 64.270353,
        spawnSvgX: 72.805341,
        spawnSvgY: 208.870328,
        startLane: 0.511985,
        routeEndS: 5724.973535,
        finishCourierPlaceSvgX: 5794.389993,
        finishCourierPlaceSvgY: 208.870328,
        laneMin: 0.084946,
        laneMax: 0.746237
      },
      staticObstacles: [
        {
          id: "static_4",
          s: 276.364241,
          lane: 0.726245
        },
        {
          id: "static_7",
          s: 661.526368,
          lane: 0.726245
        },
        {
          id: "static_9",
          s: 1811.919785,
          lane: 0.726245
        },
        {
          id: "static_13",
          s: 2411.516274,
          lane: 0.516321
        },
        {
          id: "static_14",
          s: 3027.134444,
          lane: 0.726245
        },
        {
          id: "static_18",
          s: 3500.095383,
          lane: 0.726245
        },
        {
          id: "static_20",
          s: 4017.967527,
          lane: 0.726245
        },
        {
          id: "static_23",
          s: 4603.360268,
          lane: 0.726245
        },
        {
          id: "static_25",
          s: 5222.421492,
          lane: 0.519547
        },
        {
          id: "static_26",
          s: 5566.267883,
          lane: 0.538901
        }
      ],
      movingObstacles: [
        {
          id: "static",
          s: 264.698253,
          lane: 0.493756
        },
        {
          id: "static_3",
          s: 855.985504,
          lane: 0.493756
        },
        {
          id: "static_5",
          s: 1333.711631,
          lane: 0.493756
        },
        {
          id: "static_10",
          s: 1912.314668,
          lane: 0.493756
        },
        {
          id: "static_12",
          s: 2310.790858,
          lane: 0.493756
        },
        {
          id: "static_16",
          s: 2913.688089,
          lane: 0.493756
        },
        {
          id: "static_15",
          s: 3436.077521,
          lane: 0.493756
        },
        {
          id: "static_22",
          s: 4349.079206,
          lane: 0.493756
        },
        {
          id: "static_24",
          s: 4797.594457,
          lane: 0.493756
        },
        {
          id: "static_27",
          s: 5562.411661,
          lane: 0.493756
        }
      ],
      boosters: [
        {
          id: "speed",
          s: 1339.578596,
          lane: 0.726245,
          type: "speed"
        },
        {
          id: "shield",
          s: 3765.430946,
          lane: 0.726245,
          type: "shield"
        }
      ],
      sparks: [
        {
          id: "small_2",
          s: 852.042059,
          lane: 0.302342
        },
        {
          id: "small",
          s: 2775.561918,
          lane: 0.495891
        },
        {
          id: "small_3",
          s: 4861.589366,
          lane: 0.500192
        }
      ]
    },
    {
      giantId: "mona",
      route: {
        viewBoxWidth: 6276,
        viewBoxHeight: 428,
        startPointSvgX: 64.270353,
        spawnSvgX: 72.805341,
        spawnSvgY: 208.870328,
        startLane: 0.511985,
        routeEndS: 5724.973535,
        finishCourierPlaceSvgX: 5794.389993,
        finishCourierPlaceSvgY: 208.870328,
        laneMin: 0.083871,
        laneMax: 0.745161
      },
      staticObstacles: [
        {
          id: "static_4",
          s: 1811.919785,
          lane: 0.72517
        },
        {
          id: "static_7",
          s: 2411.516274,
          lane: 0.516321
        },
        {
          id: "static_10",
          s: 3027.134444,
          lane: 0.72517
        },
        {
          id: "static_12",
          s: 4586.604069,
          lane: 0.586213
        },
        {
          id: "static_13",
          s: 5205.89483,
          lane: 0.72517
        },
        {
          id: "static_14",
          s: 5461.139948,
          lane: 0.500192
        }
      ],
      movingObstacles: [
        {
          id: "static",
          s: 231.944245,
          lane: 0.493756
        },
        {
          id: "static_2",
          s: 724.690354,
          lane: 0.493756
        },
        {
          id: "static_5",
          s: 1333.711631,
          lane: 0.493756
        },
        {
          id: "static_9",
          s: 1811.873878,
          lane: 0.493756
        },
        {
          id: "static_11",
          s: 2522.584626,
          lane: 0.493756
        },
        {
          id: "static_16",
          s: 2913.688089,
          lane: 0.493756
        },
        {
          id: "static_15",
          s: 3436.082111,
          lane: 0.493756
        },
        {
          id: "static_23",
          s: 4123.214821,
          lane: 0.493756
        },
        {
          id: "static_26",
          s: 4869.714975,
          lane: 0.493756
        },
        {
          id: "static_29",
          s: 5330.120242,
          lane: 0.493756
        }
      ],
      boosters: [
        {
          id: "speed",
          s: 1339.578596,
          lane: 0.72517,
          type: "speed"
        },
        {
          id: "shield",
          s: 3765.430946,
          lane: 0.72517,
          type: "shield"
        }
      ],
      sparks: [
        {
          id: "small_2",
          s: 882.340939,
          lane: 0.72517
        },
        {
          id: "small",
          s: 2775.561918,
          lane: 0.495891
        },
        {
          id: "small_3",
          s: 5214.158161,
          lane: 0.258256
        }
      ]
    }
  ],
  mu: [
    {
      giantId: "mu",
      route: {
        viewBoxWidth: 6276,
        viewBoxHeight: 428,
        startPointSvgX: 64.270353,
        spawnSvgX: 72.805341,
        spawnSvgY: 208.873089,
        startLane: 0.511979,
        routeEndS: 5724.973535,
        finishCourierPlaceSvgX: 5794.389993,
        finishCourierPlaceSvgY: 208.873089,
        laneMin: 0.077419,
        laneMax: 0.73871
      },
      staticObstacles: [
        {
          id: "static",
          s: 751.504863,
          lane: 0.499835
        },
        {
          id: "static_2",
          s: 1110.959768,
          lane: 0.23962
        },
        {
          id: "static_3",
          s: 1717.855532,
          lane: 0.440695
        },
        {
          id: "static_4",
          s: 2080.064881,
          lane: 0.440695
        },
        {
          id: "static_5",
          s: 2610.295295,
          lane: 0.279405
        },
        {
          id: "static_6",
          s: 3113.256717,
          lane: 0.805379
        },
        {
          id: "static_7",
          s: 3347.568063,
          lane: 0.298759
        },
        {
          id: "static_8",
          s: 3701.169774,
          lane: 0.551371
        },
        {
          id: "static_10",
          s: 4190.427839,
          lane: 0.737469
        },
        {
          id: "static_9",
          s: 4355.694461,
          lane: 0.272953
        },
        {
          id: "static_11",
          s: 4762.750744,
          lane: 0.483168
        },
        {
          id: "static_12",
          s: 5477.712517,
          lane: 0.345581
        }
      ],
      movingObstacles: [],
      boosters: [
        {
          id: "shield",
          s: 414.085508,
          lane: 0.417039,
          type: "shield"
        },
        {
          id: "speed",
          s: 2896.298368,
          lane: 0.50306,
          type: "speed"
        },
        {
          id: "shield_2",
          s: 5041.087281,
          lane: 0.48048,
          type: "shield"
        }
      ],
      sparks: [
        {
          id: "small_3",
          s: 1345.546557,
          lane: 0.46005
        },
        {
          id: "small_2",
          s: 2373.87221,
          lane: 0.361125
        },
        {
          id: "small",
          s: 4094.022309,
          lane: 0.40091
        }
      ]
    },
    {
      giantId: "mu",
      route: {
        viewBoxWidth: 6276,
        viewBoxHeight: 428,
        startPointSvgX: 64.270353,
        spawnSvgX: 72.805341,
        spawnSvgY: 208.873089,
        startLane: 0.511979,
        routeEndS: 5724.973535,
        finishCourierPlaceSvgX: 5794.389993,
        finishCourierPlaceSvgY: 208.873089,
        laneMin: 0.075269,
        laneMax: 0.736559
      },
      staticObstacles: [
        {
          id: "static_2",
          s: 414.085508,
          lane: 0.70091
        },
        {
          id: "static_3",
          s: 751.504863,
          lane: 0.499835
        },
        {
          id: "static_5",
          s: 1110.959768,
          lane: 0.23962
        },
        {
          id: "static_4",
          s: 1127.945504,
          lane: 0.70091
        },
        {
          id: "static_7",
          s: 1602.62797,
          lane: 0.744996
        },
        {
          id: "static_6",
          s: 1717.855532,
          lane: 0.440695
        },
        {
          id: "static_8",
          s: 2080.064881,
          lane: 0.440695
        },
        {
          id: "static_9",
          s: 2337.146294,
          lane: 0.696609
        },
        {
          id: "static_10",
          s: 2610.295295,
          lane: 0.279405
        },
        {
          id: "static_11",
          s: 2839.373197,
          lane: 0.765426
        },
        {
          id: "static_12",
          s: 3113.256717,
          lane: 0.805379
        },
        {
          id: "static_13",
          s: 3347.568063,
          lane: 0.298759
        },
        {
          id: "static_14",
          s: 3701.169774,
          lane: 0.551371
        },
        {
          id: "static_15",
          s: 3950.189849,
          lane: 0.196825
        },
        {
          id: "static_17",
          s: 4190.427839,
          lane: 0.737469
        },
        {
          id: "static_16",
          s: 4355.694461,
          lane: 0.272953
        },
        {
          id: "static_18",
          s: 4762.750744,
          lane: 0.483168
        },
        {
          id: "static",
          s: 4988.706943,
          lane: 0.851239
        },
        {
          id: "static_19",
          s: 5433.503696,
          lane: 0.818901
        },
        {
          id: "static_20",
          s: 5477.712517,
          lane: 0.345581
        }
      ],
      movingObstacles: [],
      boosters: [
        {
          id: "shield",
          s: 414.085508,
          lane: 0.417039,
          type: "shield"
        },
        {
          id: "speed",
          s: 2839.373197,
          lane: 0.42134,
          type: "speed"
        },
        {
          id: "shield_2",
          s: 4971.767115,
          lane: 0.442845,
          type: "shield"
        }
      ],
      sparks: [
        {
          id: "small_3",
          s: 1345.546557,
          lane: 0.46005
        },
        {
          id: "small_2",
          s: 2373.87221,
          lane: 0.361125
        },
        {
          id: "small",
          s: 4094.022309,
          lane: 0.40091
        }
      ]
    },
    {
      giantId: "mu",
      route: {
        viewBoxWidth: 6276,
        viewBoxHeight: 428,
        startPointSvgX: 64.270353,
        spawnSvgX: 72.805341,
        spawnSvgY: 208.873089,
        startLane: 0.511979,
        routeEndS: 5724.973535,
        finishCourierPlaceSvgX: 5794.389993,
        finishCourierPlaceSvgY: 208.873089,
        laneMin: 0.074194,
        laneMax: 0.735484
      },
      staticObstacles: [
        {
          id: "static_3",
          s: 225.166018,
          lane: 0.105099
        },
        {
          id: "static_2",
          s: 264.577517,
          lane: 0.812433
        },
        {
          id: "static_4",
          s: 514.099359,
          lane: 0.72071
        },
        {
          id: "static_5",
          s: 602.966895,
          lane: 0.106276
        },
        {
          id: "static_6",
          s: 838.26984,
          lane: 0.46005
        },
        {
          id: "static_7",
          s: 1127.945504,
          lane: 0.70091
        },
        {
          id: "static_8",
          s: 1336.365078,
          lane: 0.207362
        },
        {
          id: "static_9",
          s: 1594.029515,
          lane: 0.400851
        },
        {
          id: "static_10",
          s: 1903.321409,
          lane: 0.279405
        },
        {
          id: "static_11",
          s: 2040.584521,
          lane: 0.717039
        },
        {
          id: "static_12",
          s: 2337.146294,
          lane: 0.696609
        },
        {
          id: "static_13",
          s: 2610.295295,
          lane: 0.279405
        },
        {
          id: "static_14",
          s: 2839.373197,
          lane: 0.765426
        },
        {
          id: "static_15",
          s: 3113.256717,
          lane: 0.805379
        },
        {
          id: "static_16",
          s: 3454.073219,
          lane: 0.298759
        },
        {
          id: "static_17",
          s: 3701.165183,
          lane: 0.551371
        },
        {
          id: "static_18",
          s: 3950.189849,
          lane: 0.196825
        },
        {
          id: "static_20",
          s: 4190.427839,
          lane: 0.737469
        },
        {
          id: "static_19",
          s: 4355.694461,
          lane: 0.272953
        },
        {
          id: "static_21",
          s: 4551.16356,
          lane: 0.477287
        },
        {
          id: "static_22",
          s: 4762.750744,
          lane: 0.483168
        },
        {
          id: "static_23",
          s: 4783.363165,
          lane: 0.130971
        },
        {
          id: "static",
          s: 4988.706943,
          lane: 0.851239
        },
        {
          id: "static_24",
          s: 5329.339816,
          lane: 0.190356
        },
        {
          id: "static_25",
          s: 5433.503696,
          lane: 0.818901
        },
        {
          id: "static_26",
          s: 5477.712517,
          lane: 0.345581
        }
      ],
      movingObstacles: [],
      boosters: [
        {
          id: "shield",
          s: 414.085508,
          lane: 0.417039,
          type: "shield"
        },
        {
          id: "speed",
          s: 1419.916537,
          lane: 0.520265,
          type: "speed"
        },
        {
          id: "speed_2",
          s: 3112.981273,
          lane: 0.31919,
          type: "speed"
        },
        {
          id: "shield_2",
          s: 4971.767115,
          lane: 0.442845,
          type: "shield"
        }
      ],
      sparks: [
        {
          id: "small_3",
          s: 2176.470411,
          lane: 0.340695
        },
        {
          id: "small_2",
          s: 2601.57289,
          lane: 0.577254
        },
        {
          id: "small",
          s: 4094.022309,
          lane: 0.40091
        }
      ]
    }
  ],
  roza: [
    {
      giantId: "roza",
      route: {
        viewBoxWidth: 6276,
        viewBoxHeight: 428,
        startPointSvgX: 64.270353,
        spawnSvgX: 72.805341,
        spawnSvgY: 208.870788,
        startLane: 0.511984,
        routeEndS: 5724.973535,
        finishCourierPlaceSvgX: 5794.389993,
        finishCourierPlaceSvgY: 208.870788,
        laneMin: 0.084946,
        laneMax: 0.746237
      },
      staticObstacles: [
        {
          id: "static_2",
          s: 732.246711,
          lane: 0.777158
        },
        {
          id: "static",
          s: 925.287308,
          lane: 0.102752
        },
        {
          id: "static_3",
          s: 1292.794369,
          lane: 0.156257
        },
        {
          id: "static_4",
          s: 1438.279496,
          lane: 0.520222
        },
        {
          id: "static_5",
          s: 1868.404244,
          lane: 0.379687
        },
        {
          id: "static_6",
          s: 2483.926009,
          lane: 0.860063
        },
        {
          id: "static_7",
          s: 2721.850266,
          lane: 0.59334
        },
        {
          id: "static_9",
          s: 3027.354799,
          lane: 0.408128
        },
        {
          id: "static_8",
          s: 3316.539254,
          lane: 0.57335
        },
        {
          id: "static_11",
          s: 3675.310138,
          lane: 0.074528
        },
        {
          id: "static_10",
          s: 3727.52521,
          lane: 0.839484
        },
        {
          id: "static_12",
          s: 3956.96578,
          lane: 0.42261
        },
        {
          id: "static_15",
          s: 4357.6088,
          lane: 0.777747
        },
        {
          id: "static_13",
          s: 4543.634747,
          lane: 0.156845
        },
        {
          id: "static_14",
          s: 4770.279557,
          lane: 0.865355
        },
        {
          id: "static_16",
          s: 5284.166939,
          lane: 0.22211
        },
        {
          id: "static_17",
          s: 5496.764086,
          lane: 0.236222
        }
      ],
      movingObstacles: [],
      boosters: [
        {
          id: "shield",
          s: 617.455269,
          lane: 0.480437,
          type: "shield"
        },
        {
          id: "speed",
          s: 2138.826346,
          lane: 0.500867,
          type: "speed"
        },
        {
          id: "shield_2",
          s: 3398.929256,
          lane: 0.182129,
          type: "shield"
        },
        {
          id: "shield_3",
          s: 4653.077977,
          lane: 0.357345,
          type: "shield"
        }
      ],
      sparks: [
        {
          id: "small",
          s: 1055.820395,
          lane: 0.676028
        },
        {
          id: "small_2",
          s: 2721.850266,
          lane: 0.258931
        },
        {
          id: "small_3",
          s: 4198.232096,
          lane: 0.480437
        },
        {
          id: "small_4",
          s: 5049.809686,
          lane: 0.480437
        }
      ]
    },
    {
      giantId: "roza",
      route: {
        viewBoxWidth: 6276,
        viewBoxHeight: 428,
        startPointSvgX: 64.270353,
        spawnSvgX: 72.805341,
        spawnSvgY: 208.870788,
        startLane: 0.511984,
        routeEndS: 5724.973535,
        finishCourierPlaceSvgX: 5794.389993,
        finishCourierPlaceSvgY: 208.870788,
        laneMin: 0.082796,
        laneMax: 0.744086
      },
      staticObstacles: [
        {
          id: "static_2",
          s: 411.790138,
          lane: 0.480437
        },
        {
          id: "static",
          s: 972.319434,
          lane: 0.499792
        },
        {
          id: "static_3",
          s: 1722.905346,
          lane: 0.460007
        },
        {
          id: "static_4",
          s: 2138.826346,
          lane: 0.155706
        },
        {
          id: "static_5",
          s: 2483.926009,
          lane: 0.860063
        },
        {
          id: "static_7",
          s: 3027.354799,
          lane: 0.408128
        },
        {
          id: "static_6",
          s: 3316.539254,
          lane: 0.57335
        },
        {
          id: "static_9",
          s: 3675.310138,
          lane: 0.074528
        },
        {
          id: "static_8",
          s: 3727.52521,
          lane: 0.839484
        },
        {
          id: "static_11",
          s: 4357.6088,
          lane: 0.777747
        },
        {
          id: "static_10",
          s: 4770.279557,
          lane: 0.865355
        },
        {
          id: "static_12",
          s: 5284.166939,
          lane: 0.22211
        },
        {
          id: "static_13",
          s: 5496.764086,
          lane: 0.236222
        }
      ],
      movingObstacles: [],
      boosters: [
        {
          id: "shield",
          s: 694.120619,
          lane: 0.479362,
          type: "shield"
        },
        {
          id: "speed",
          s: 2138.826346,
          lane: 0.500867,
          type: "speed"
        },
        {
          id: "shield_2",
          s: 3398.929256,
          lane: 0.182129,
          type: "shield"
        },
        {
          id: "shield_3",
          s: 4653.077977,
          lane: 0.357345,
          type: "shield"
        }
      ],
      sparks: [
        {
          id: "small",
          s: 1316.165824,
          lane: 0.480437
        },
        {
          id: "small_2",
          s: 2721.850266,
          lane: 0.258931
        },
        {
          id: "small_3",
          s: 4198.232096,
          lane: 0.480437
        },
        {
          id: "small_4",
          s: 5049.809686,
          lane: 0.480437
        }
      ]
    },
    {
      giantId: "roza",
      route: {
        viewBoxWidth: 6276,
        viewBoxHeight: 428,
        startPointSvgX: 64.270353,
        spawnSvgX: 72.805341,
        spawnSvgY: 208.870788,
        startLane: 0.511984,
        routeEndS: 5724.973535,
        finishCourierPlaceSvgX: 5794.389993,
        finishCourierPlaceSvgY: 208.870788,
        laneMin: 0.08172,
        laneMax: 0.743011
      },
      staticObstacles: [
        {
          id: "static_3",
          s: 386.577797,
          lane: 0.777158
        },
        {
          id: "static_4",
          s: 732.246711,
          lane: 0.777158
        },
        {
          id: "static",
          s: 925.287308,
          lane: 0.102752
        },
        {
          id: "static_2",
          s: 1057.831139,
          lane: 0.920036
        },
        {
          id: "static_6",
          s: 1273.214865,
          lane: 0.833016
        },
        {
          id: "static_5",
          s: 1292.794369,
          lane: 0.156257
        },
        {
          id: "static_7",
          s: 1512.194993,
          lane: 0.624285
        },
        {
          id: "static_9",
          s: 1673.352903,
          lane: 0.076881
        },
        {
          id: "static_8",
          s: 1868.404244,
          lane: 0.379687
        },
        {
          id: "static_10",
          s: 2301.67824,
          lane: 0.150378
        },
        {
          id: "static_11",
          s: 2483.926009,
          lane: 0.860063
        },
        {
          id: "static_13",
          s: 2730.187049,
          lane: 0.260329
        },
        {
          id: "static_12",
          s: 2761.564753,
          lane: 0.909453
        },
        {
          id: "static_17",
          s: 3067.069287,
          lane: 0.724241
        },
        {
          id: "static_15",
          s: 3345.708813,
          lane: 0.48082
        },
        {
          id: "static_14",
          s: 3356.253742,
          lane: 0.889462
        },
        {
          id: "static_16",
          s: 3466.706935,
          lane: 0.671911
        },
        {
          id: "static_20",
          s: 3675.310138,
          lane: 0.074528
        },
        {
          id: "static_18",
          s: 3727.52521,
          lane: 0.839484
        },
        {
          id: "static_19",
          s: 3811.618376,
          lane: 0.346762
        },
        {
          id: "static_21",
          s: 3956.96578,
          lane: 0.42261
        },
        {
          id: "static_24",
          s: 4357.6088,
          lane: 0.777747
        },
        {
          id: "static_22",
          s: 4543.634747,
          lane: 0.156845
        },
        {
          id: "static_23",
          s: 4770.279557,
          lane: 0.865355
        },
        {
          id: "static_28",
          s: 4956.296322,
          lane: 0.074528
        },
        {
          id: "static_25",
          s: 5284.166939,
          lane: 0.22211
        },
        {
          id: "static_26",
          s: 5430.244271,
          lane: 0.771279
        },
        {
          id: "static_27",
          s: 5496.764086,
          lane: 0.236222
        }
      ],
      movingObstacles: [],
      boosters: [
        {
          id: "shield",
          s: 386.541989,
          lane: 0.299792,
          type: "shield"
        },
        {
          id: "shield_2",
          s: 2138.826346,
          lane: 0.500867,
          type: "shield"
        },
        {
          id: "shield_3",
          s: 3398.929256,
          lane: 0.182129,
          type: "shield"
        },
        {
          id: "shield_4",
          s: 4653.077977,
          lane: 0.357345,
          type: "shield"
        }
      ],
      sparks: [
        {
          id: "small",
          s: 1055.820395,
          lane: 0.676028
        },
        {
          id: "small_2",
          s: 2424.434615,
          lane: 0.230344
        },
        {
          id: "small_3",
          s: 4198.232096,
          lane: 0.480437
        },
        {
          id: "small_4",
          s: 5049.809686,
          lane: 0.480437
        }
      ]
    }
  ],
  serj: [
    {
      giantId: "serj",
      route: {
        viewBoxWidth: 6276,
        viewBoxHeight: 428,
        startPointSvgX: 64.270353,
        spawnSvgX: 72.805341,
        spawnSvgY: 208.872169,
        startLane: 0.511981,
        routeEndS: 5724.973535,
        finishCourierPlaceSvgX: 5794.389993,
        finishCourierPlaceSvgY: 208.872169,
        laneMin: 0.078495,
        laneMax: 0.739785
      },
      staticObstacles: [
        {
          id: "static",
          s: 741.405236,
          lane: 0.47218
        },
        {
          id: "static_2",
          s: 1109.582546,
          lane: 0.237771
        },
        {
          id: "static_3",
          s: 1582.88779,
          lane: 0.447449
        },
        {
          id: "static_4",
          s: 1985.380878,
          lane: 0.512567
        },
        {
          id: "static_5",
          s: 2427.69404,
          lane: 0.507274
        },
        {
          id: "static_6",
          s: 2983.724411,
          lane: 0.76716
        },
        {
          id: "static_7",
          s: 3146.893066,
          lane: 0.216815
        },
        {
          id: "static_8",
          s: 3288.976454,
          lane: 0.742465
        },
        {
          id: "static_10",
          s: 3712.210503,
          lane: 0.762456
        },
        {
          id: "static_9",
          s: 3988.4353,
          lane: 0.428094
        },
        {
          id: "static_11",
          s: 4553.413022,
          lane: 0.329707
        },
        {
          id: "static_12",
          s: 4801.450678,
          lane: 0.708739
        },
        {
          id: "static_13",
          s: 5333.976463,
          lane: 0.807664
        },
        {
          id: "static_14",
          s: 5499.243086,
          lane: 0.254976
        }
      ],
      movingObstacles: [],
      boosters: [
        {
          id: "shield_2",
          s: 408.576621,
          lane: 0.515191,
          type: "shield"
        },
        {
          id: "speed",
          s: 2753.526368,
          lane: 0.49261,
          type: "speed"
        },
        {
          id: "speed_2",
          s: 3703.809449,
          lane: 0.428094,
          type: "speed"
        },
        {
          id: "shield",
          s: 4876.279732,
          lane: 0.388309,
          type: "shield"
        }
      ],
      sparks: [
        {
          id: "small_3",
          s: 1109.582546,
          lane: 0.648524
        },
        {
          id: "small_2",
          s: 2210.900957,
          lane: 0.49261
        },
        {
          id: "small_4",
          s: 3146.952745,
          lane: 0.519492
        },
        {
          id: "small",
          s: 4268.929485,
          lane: 0.479707
        }
      ]
    },
    {
      giantId: "serj",
      route: {
        viewBoxWidth: 6276,
        viewBoxHeight: 428,
        startPointSvgX: 64.270353,
        spawnSvgX: 72.805341,
        spawnSvgY: 208.872169,
        startLane: 0.511981,
        routeEndS: 5724.973535,
        finishCourierPlaceSvgX: 5794.389993,
        finishCourierPlaceSvgY: 208.872169,
        laneMin: 0.076344,
        laneMax: 0.737634
      },
      staticObstacles: [
        {
          id: "static",
          s: 595.878793,
          lane: 0.275406
        },
        {
          id: "static_2",
          s: 888.308901,
          lane: 0.804438
        },
        {
          id: "static_3",
          s: 1109.582546,
          lane: 0.315191
        },
        {
          id: "static_4",
          s: 1603.087044,
          lane: 0.807664
        },
        {
          id: "static_5",
          s: 1740.630191,
          lane: 0.149786
        },
        {
          id: "static_6",
          s: 1985.380878,
          lane: 0.512567
        },
        {
          id: "static_7",
          s: 2181.437591,
          lane: 0.834777
        },
        {
          id: "static_8",
          s: 2427.69404,
          lane: 0.507274
        },
        {
          id: "static_9",
          s: 2738.836002,
          lane: 0.79476
        },
        {
          id: "static_10",
          s: 2983.724411,
          lane: 0.76716
        },
        {
          id: "static_11",
          s: 3146.893066,
          lane: 0.216815
        },
        {
          id: "static_12",
          s: 3288.976454,
          lane: 0.742465
        },
        {
          id: "static_14",
          s: 3712.210503,
          lane: 0.762456
        },
        {
          id: "static_13",
          s: 3988.4353,
          lane: 0.428094
        },
        {
          id: "static_18",
          s: 4268.929485,
          lane: 0.781857
        },
        {
          id: "static_15",
          s: 4553.413022,
          lane: 0.329707
        },
        {
          id: "static_16",
          s: 4801.450678,
          lane: 0.708739
        },
        {
          id: "static_17",
          s: 5093.880786,
          lane: 0.254976
        },
        {
          id: "static_19",
          s: 5333.976463,
          lane: 0.807664
        },
        {
          id: "static_20",
          s: 5499.243086,
          lane: 0.254976
        }
      ],
      movingObstacles: [],
      boosters: [
        {
          id: "shield_2",
          s: 408.576621,
          lane: 0.515191,
          type: "shield"
        },
        {
          id: "shield_3",
          s: 1337.283226,
          lane: 0.47218,
          type: "shield"
        },
        {
          id: "speed",
          s: 2641.971398,
          lane: 0.428094,
          type: "speed"
        },
        {
          id: "speed_2",
          s: 3703.809449,
          lane: 0.428094,
          type: "speed"
        },
        {
          id: "shield",
          s: 4876.279732,
          lane: 0.388309,
          type: "shield"
        }
      ],
      sparks: [
        {
          id: "small_3",
          s: 741.405236,
          lane: 0.554976
        },
        {
          id: "small_2",
          s: 2198.25806,
          lane: 0.176838
        },
        {
          id: "small_4",
          s: 2872.270437,
          lane: 0.408499
        },
        {
          id: "small",
          s: 4268.929485,
          lane: 0.479707
        }
      ]
    },
    {
      giantId: "serj",
      route: {
        viewBoxWidth: 6276,
        viewBoxHeight: 428,
        startPointSvgX: 64.270353,
        spawnSvgX: 72.805341,
        spawnSvgY: 208.872169,
        startLane: 0.511981,
        routeEndS: 5724.973535,
        finishCourierPlaceSvgX: 5794.389993,
        finishCourierPlaceSvgY: 208.872169,
        laneMin: 0.075269,
        laneMax: 0.736559
      },
      staticObstacles: [
        {
          id: "static",
          s: 399.882219,
          lane: 0.844185
        },
        {
          id: "static_2",
          s: 595.878793,
          lane: 0.275406
        },
        {
          id: "static_3",
          s: 871.313983,
          lane: 0.315596
        },
        {
          id: "static_4",
          s: 888.308901,
          lane: 0.804438
        },
        {
          id: "static_5",
          s: 1168.344012,
          lane: 0.295836
        },
        {
          id: "static_6",
          s: 1296.884718,
          lane: 0.466803
        },
        {
          id: "static_7",
          s: 1603.087044,
          lane: 0.807664
        },
        {
          id: "static_8",
          s: 1740.630191,
          lane: 0.149786
        },
        {
          id: "static_9",
          s: 1985.380878,
          lane: 0.512567
        },
        {
          id: "static_10",
          s: 2181.437591,
          lane: 0.834777
        },
        {
          id: "static_11",
          s: 2427.69404,
          lane: 0.507274
        },
        {
          id: "static_14",
          s: 2579.078267,
          lane: 0.747449
        },
        {
          id: "static_13",
          s: 2740.479487,
          lane: 0.559603
        },
        {
          id: "static_12",
          s: 2869.006421,
          lane: 0.070409
        },
        {
          id: "static_15",
          s: 2983.724411,
          lane: 0.76716
        },
        {
          id: "static_16",
          s: 3146.893066,
          lane: 0.216815
        },
        {
          id: "static_17",
          s: 3288.976454,
          lane: 0.742465
        },
        {
          id: "static_18",
          s: 3684.349305,
          lane: 0.115096
        },
        {
          id: "static_21",
          s: 3712.210503,
          lane: 0.762456
        },
        {
          id: "static_19",
          s: 3988.4353,
          lane: 0.428094
        },
        {
          id: "static_25",
          s: 4268.929485,
          lane: 0.781857
        },
        {
          id: "static_20",
          s: 4285.814224,
          lane: 0.133911
        },
        {
          id: "static_22",
          s: 4553.413022,
          lane: 0.329707
        },
        {
          id: "static_23",
          s: 4801.450678,
          lane: 0.708739
        },
        {
          id: "static_24",
          s: 5093.880786,
          lane: 0.254976
        },
        {
          id: "static_26",
          s: 5333.976463,
          lane: 0.807664
        },
        {
          id: "static_27",
          s: 5499.243086,
          lane: 0.254976
        }
      ],
      movingObstacles: [],
      boosters: [
        {
          id: "shield_2",
          s: 408.576621,
          lane: 0.515191,
          type: "shield"
        },
        {
          id: "shield_3",
          s: 1159.621607,
          lane: 0.727019,
          type: "shield"
        },
        {
          id: "shield_4",
          s: 2570.53031,
          lane: 0.409083,
          type: "shield"
        },
        {
          id: "speed",
          s: 3703.809449,
          lane: 0.428094,
          type: "speed"
        },
        {
          id: "shield",
          s: 4876.279732,
          lane: 0.388309,
          type: "shield"
        }
      ],
      sparks: [
        {
          id: "small_3",
          s: 741.405236,
          lane: 0.554976
        },
        {
          id: "small_2",
          s: 2198.25806,
          lane: 0.176838
        },
        {
          id: "small_4",
          s: 2872.270437,
          lane: 0.408499
        },
        {
          id: "small",
          s: 4268.929485,
          lane: 0.479707
        }
      ]
    }
  ],
  sol: [
    {
      giantId: "sol",
      route: {
        viewBoxWidth: 6276,
        viewBoxHeight: 428,
        startPointSvgX: 64.270353,
        spawnSvgX: 72.805341,
        spawnSvgY: 208.872169,
        startLane: 0.511981,
        routeEndS: 5724.973535,
        finishCourierPlaceSvgX: 5794.389993,
        finishCourierPlaceSvgY: 208.872169,
        laneMin: 0.07957,
        laneMax: 0.74086
      },
      staticObstacles: [
        {
          id: "static",
          s: 583.483797,
          lane: 0.799364
        },
        {
          id: "static_2",
          s: 583.483797,
          lane: 0.249901
        },
        {
          id: "static_3",
          s: 1225.728256,
          lane: 0.500439
        },
        {
          id: "static_4",
          s: 2521.694023,
          lane: 0.424095
        },
        {
          id: "static_6",
          s: 2909.152438,
          lane: 0.733772
        },
        {
          id: "static_5",
          s: 3234.176796,
          lane: 0.388611
        },
        {
          id: "static_7",
          s: 3539.460975,
          lane: 0.733772
        },
        {
          id: "static_8",
          s: 3782.311095,
          lane: 0.295063
        },
        {
          id: "static_9",
          s: 4067.671464,
          lane: 0.564898
        },
        {
          id: "static_10",
          s: 4489.284982,
          lane: 0.255278
        },
        {
          id: "static_11",
          s: 4759.215875,
          lane: 0.654202
        },
        {
          id: "static_12",
          s: 5325.850854,
          lane: 0.388506
        }
      ],
      movingObstacles: [],
      boosters: [
        {
          id: "shield",
          s: 2215.032623,
          lane: 0.444525,
          type: "shield"
        },
        {
          id: "speed",
          s: 3539.460975,
          lane: 0.462805,
          type: "speed"
        },
        {
          id: "shield_2",
          s: 4383.238899,
          lane: 0.564955,
          type: "shield"
        }
      ],
      sparks: [
        {
          id: "small",
          s: 1670.111841,
          lane: 0.46388
        },
        {
          id: "small_2",
          s: 2900.430033,
          lane: 0.44345
        },
        {
          id: "small_3",
          s: 3909.933654,
          lane: 0.483235
        }
      ]
    },
    {
      giantId: "sol",
      route: {
        viewBoxWidth: 6276,
        viewBoxHeight: 428,
        startPointSvgX: 64.270353,
        spawnSvgX: 72.805341,
        spawnSvgY: 208.872169,
        startLane: 0.511981,
        routeEndS: 5724.973535,
        finishCourierPlaceSvgX: 5794.389993,
        finishCourierPlaceSvgY: 208.872169,
        laneMin: 0.077419,
        laneMax: 0.73871
      },
      staticObstacles: [
        {
          id: "static",
          s: 583.483797,
          lane: 0.799364
        },
        {
          id: "static_2",
          s: 947.625846,
          lane: 0.52374
        },
        {
          id: "static_3",
          s: 1621.909076,
          lane: 0.412267
        },
        {
          id: "static_5",
          s: 2273.312061,
          lane: 0.681317
        },
        {
          id: "static_4",
          s: 2616.722331,
          lane: 0.661729
        },
        {
          id: "static_7",
          s: 2883.315756,
          lane: 0.604881
        },
        {
          id: "static_6",
          s: 3234.176796,
          lane: 0.388611
        },
        {
          id: "static_8",
          s: 3539.460975,
          lane: 0.733772
        },
        {
          id: "static_9",
          s: 3782.311095,
          lane: 0.295063
        },
        {
          id: "static_10",
          s: 4067.671464,
          lane: 0.564898
        },
        {
          id: "static_11",
          s: 4489.284982,
          lane: 0.255278
        },
        {
          id: "static_12",
          s: 4759.215875,
          lane: 0.654202
        },
        {
          id: "static_13",
          s: 5325.850854,
          lane: 0.388506
        }
      ],
      movingObstacles: [],
      boosters: [
        {
          id: "shield",
          s: 600.469533,
          lane: 0.391837,
          type: "shield"
        },
        {
          id: "shield_2",
          s: 1981.363981,
          lane: 0.483235,
          type: "shield"
        },
        {
          id: "speed",
          s: 3135.016823,
          lane: 0.605815,
          type: "speed"
        },
        {
          id: "shield_3",
          s: 4383.238899,
          lane: 0.564955,
          type: "shield"
        }
      ],
      sparks: [
        {
          id: "small",
          s: 1285.407869,
          lane: 0.431622
        },
        {
          id: "small_2",
          s: 2667.179149,
          lane: 0.295019
        },
        {
          id: "small_3",
          s: 3522.475238,
          lane: 0.255278
        }
      ]
    },
    {
      giantId: "sol",
      route: {
        viewBoxWidth: 6276,
        viewBoxHeight: 428,
        startPointSvgX: 64.270353,
        spawnSvgX: 72.805341,
        spawnSvgY: 208.872169,
        startLane: 0.511981,
        routeEndS: 5724.973535,
        finishCourierPlaceSvgX: 5794.389993,
        finishCourierPlaceSvgY: 208.872169,
        laneMin: 0.076344,
        laneMax: 0.737634
      },
      staticObstacles: [
        {
          id: "static",
          s: 314.281454,
          lane: 0.095695
        },
        {
          id: "static_2",
          s: 667.980948,
          lane: 0.471999
        },
        {
          id: "static_3",
          s: 938.33878,
          lane: 0.145085
        },
        {
          id: "static_4",
          s: 947.625846,
          lane: 0.52374
        },
        {
          id: "static_6",
          s: 1440.147926,
          lane: 0.196827
        },
        {
          id: "static_5",
          s: 1621.909076,
          lane: 0.412267
        },
        {
          id: "static_7",
          s: 2243.192219,
          lane: 0.156844
        },
        {
          id: "static_9",
          s: 2273.312061,
          lane: 0.681317
        },
        {
          id: "static_8",
          s: 2511.038916,
          lane: 0.498458
        },
        {
          id: "static_11",
          s: 2650.106189,
          lane: 0.07982
        },
        {
          id: "static_15",
          s: 2883.315756,
          lane: 0.604881
        },
        {
          id: "static_10",
          s: 2938.289862,
          lane: 0.176836
        },
        {
          id: "static_12",
          s: 3017.865741,
          lane: 0.801852
        },
        {
          id: "static_13",
          s: 3255.340106,
          lane: 0.216817
        },
        {
          id: "static_14",
          s: 3325.876818,
          lane: 0.781862
        },
        {
          id: "static_16",
          s: 3742.087036,
          lane: 0.825959
        },
        {
          id: "static_17",
          s: 3750.62122,
          lane: 0.156844
        },
        {
          id: "static_18",
          s: 4067.671464,
          lane: 0.564898
        },
        {
          id: "static_21",
          s: 4456.764183,
          lane: 0.104515
        },
        {
          id: "static_19",
          s: 4571.730073,
          lane: 0.86359
        },
        {
          id: "static_20",
          s: 4729.651512,
          lane: 0.564898
        },
        {
          id: "static_24",
          s: 4988.706943,
          lane: 0.851243
        },
        {
          id: "static_22",
          s: 5090.345916,
          lane: 0.104515
        },
        {
          id: "static_23",
          s: 5325.850854,
          lane: 0.388506
        }
      ],
      movingObstacles: [],
      boosters: [
        {
          id: "shield",
          s: 946.877556,
          lane: 0.342057,
          type: "shield"
        },
        {
          id: "shield_2",
          s: 1981.363981,
          lane: 0.483235,
          type: "shield"
        },
        {
          id: "speed",
          s: 3096.941229,
          lane: 0.2568,
          type: "speed"
        },
        {
          id: "shield_3",
          s: 4510.485017,
          lane: 0.396739,
          type: "shield"
        }
      ],
      sparks: [
        {
          id: "small",
          s: 355.952515,
          lane: 0.460238
        },
        {
          id: "small_2",
          s: 1457.216296,
          lane: 0.696605
        },
        {
          id: "small_3",
          s: 2667.179149,
          lane: 0.295019
        },
        {
          id: "small_4",
          s: 3522.475238,
          lane: 0.255278
        }
      ]
    }
  ],
  svami: [
    {
      giantId: "svami",
      route: {
        viewBoxWidth: 6276,
        viewBoxHeight: 428,
        startPointSvgX: 64.270353,
        spawnSvgX: 72.805341,
        spawnSvgY: 208.871248,
        startLane: 0.511983,
        routeEndS: 5724.973535,
        finishCourierPlaceSvgX: 5794.389993,
        finishCourierPlaceSvgY: 208.871248,
        laneMin: 0.082796,
        laneMax: 0.744086
      },
      staticObstacles: [
        {
          id: "static",
          s: 532.425592,
          lane: 0.265031
        },
        {
          id: "static_3",
          s: 1060.590174,
          lane: 0.22505
        },
        {
          id: "static_2",
          s: 1069.128949,
          lane: 0.748935
        },
        {
          id: "static_4",
          s: 1599.552175,
          lane: 0.529621
        },
        {
          id: "static_6",
          s: 2175.41454,
          lane: 0.833603
        },
        {
          id: "static_5",
          s: 2232.477433,
          lane: 0.275536
        },
        {
          id: "static_7",
          s: 2837.123735,
          lane: 0.580774
        },
        {
          id: "static_8",
          s: 3529.214444,
          lane: 0.350287
        },
        {
          id: "static_9",
          s: 3836.220149,
          lane: 0.631339
        },
        {
          id: "static_13",
          s: 4311.623362,
          lane: 0.671235
        },
        {
          id: "static_10",
          s: 4851.948813,
          lane: 0.295966
        },
        {
          id: "static_11",
          s: 5120.966149,
          lane: 0.804568
        },
        {
          id: "static_12",
          s: 5393.197003,
          lane: 0.256181
        }
      ],
      movingObstacles: [],
      boosters: [
        {
          id: "shield",
          s: 532.526588,
          lane: 0.640052,
          type: "shield"
        },
        {
          id: "speed",
          s: 1890.467338,
          lane: 0.459407,
          type: "speed"
        },
        {
          id: "speed_2",
          s: 3366.390095,
          lane: 0.519622,
          type: "speed"
        }
      ],
      sparks: [
        {
          id: "small",
          s: 1198.183819,
          lane: 0.479837
        },
        {
          id: "small_2",
          s: 2370.658692,
          lane: 0.541127
        },
        {
          id: "small_3",
          s: 3024.393772,
          lane: 0.326768
        },
        {
          id: "small_4",
          s: 4667.860158,
          lane: 0.63145
        }
      ]
    },
    {
      giantId: "svami",
      route: {
        viewBoxWidth: 6276,
        viewBoxHeight: 428,
        startPointSvgX: 64.270353,
        spawnSvgX: 72.805341,
        spawnSvgY: 208.871248,
        startLane: 0.511983,
        routeEndS: 5724.973535,
        finishCourierPlaceSvgX: 5983.294448,
        finishCourierPlaceSvgY: 291.413695,
        laneMin: 0.080645,
        laneMax: 0.741935
      },
      staticObstacles: [
        {
          id: "static",
          s: 242.989564,
          lane: 0.773042
        },
        {
          id: "static_2",
          s: 532.425592,
          lane: 0.265031
        },
        {
          id: "static_4",
          s: 1060.590174,
          lane: 0.22505
        },
        {
          id: "static_3",
          s: 1069.128949,
          lane: 0.748935
        },
        {
          id: "static_5",
          s: 1599.552175,
          lane: 0.529621
        },
        {
          id: "static_7",
          s: 2175.41454,
          lane: 0.833603
        },
        {
          id: "static_6",
          s: 2232.477433,
          lane: 0.275536
        },
        {
          id: "static_8",
          s: 2663.162252,
          lane: 0.858885
        },
        {
          id: "static_10",
          s: 2837.123735,
          lane: 0.580774
        },
        {
          id: "static_9",
          s: 3007.325403,
          lane: 0.831839
        },
        {
          id: "static_12",
          s: 3332.909831,
          lane: 0.112157
        },
        {
          id: "static_11",
          s: 3529.214444,
          lane: 0.350287
        },
        {
          id: "static_13",
          s: 3836.220149,
          lane: 0.631339
        },
        {
          id: "static_17",
          s: 4135.196652,
          lane: 0.161548
        },
        {
          id: "static_14",
          s: 4721.342274,
          lane: 0.540792
        },
        {
          id: "static_15",
          s: 5205.848923,
          lane: 0.510806
        },
        {
          id: "static_16",
          s: 5442.822897,
          lane: 0.336177
        }
      ],
      movingObstacles: [],
      boosters: [
        {
          id: "shield",
          s: 532.526588,
          lane: 0.640052,
          type: "shield"
        },
        {
          id: "speed",
          s: 1890.467338,
          lane: 0.459407,
          type: "speed"
        },
        {
          id: "speed_2",
          s: 3366.390095,
          lane: 0.519622,
          type: "speed"
        },
        {
          id: "shield_2",
          s: 4014.951411,
          lane: 0.300899,
          type: "shield"
        }
      ],
      sparks: [
        {
          id: "small",
          s: 1198.183819,
          lane: 0.479837
        },
        {
          id: "small_2",
          s: 2370.658692,
          lane: 0.541127
        },
        {
          id: "small_3",
          s: 3024.393772,
          lane: 0.326768
        },
        {
          id: "small_4",
          s: 4484.235168,
          lane: 0.375536
        }
      ]
    },
    {
      giantId: "svami",
      route: {
        viewBoxWidth: 6276,
        viewBoxHeight: 428,
        startPointSvgX: 64.270353,
        spawnSvgX: 72.805341,
        spawnSvgY: 208.871248,
        startLane: 0.511983,
        routeEndS: 5724.973535,
        finishCourierPlaceSvgX: 5794.389993,
        finishCourierPlaceSvgY: 208.871248,
        laneMin: 0.07957,
        laneMax: 0.74086
      },
      staticObstacles: [
        {
          id: "static",
          s: 242.989564,
          lane: 0.773042
        },
        {
          id: "static_2",
          s: 532.425592,
          lane: 0.265031
        },
        {
          id: "static_3",
          s: 873.825118,
          lane: 0.845951
        },
        {
          id: "static_4",
          s: 916.500632,
          lane: 0.076292
        },
        {
          id: "static_6",
          s: 1060.590174,
          lane: 0.22505
        },
        {
          id: "static_5",
          s: 1069.128949,
          lane: 0.748935
        },
        {
          id: "static_7",
          s: 1440.400417,
          lane: 0.52374
        },
        {
          id: "static_8",
          s: 1599.552175,
          lane: 0.529621
        },
        {
          id: "static_9",
          s: 1987.892013,
          lane: 0.818903
        },
        {
          id: "static_11",
          s: 2175.41454,
          lane: 0.833603
        },
        {
          id: "static_10",
          s: 2232.477433,
          lane: 0.275536
        },
        {
          id: "static_14",
          s: 2646.093882,
          lane: 0.246216
        },
        {
          id: "static_12",
          s: 2663.162252,
          lane: 0.858885
        },
        {
          id: "static_15",
          s: 2837.123735,
          lane: 0.580774
        },
        {
          id: "static_13",
          s: 3007.325403,
          lane: 0.831839
        },
        {
          id: "static_16",
          s: 3183.04514,
          lane: 0.315598
        },
        {
          id: "static_17",
          s: 3332.909831,
          lane: 0.883581
        },
        {
          id: "static_20",
          s: 3332.909831,
          lane: 0.112157
        },
        {
          id: "static_18",
          s: 3529.214444,
          lane: 0.350287
        },
        {
          id: "static_19",
          s: 3529.214444,
          lane: 0.853595
        },
        {
          id: "static_21",
          s: 3836.220149,
          lane: 0.631339
        },
        {
          id: "static_26",
          s: 4135.196652,
          lane: 0.161548
        },
        {
          id: "static_22",
          s: 4721.342274,
          lane: 0.540792
        },
        {
          id: "static_25",
          s: 4992.195905,
          lane: 0.105102
        },
        {
          id: "static_23",
          s: 5205.848923,
          lane: 0.510806
        },
        {
          id: "static_24",
          s: 5442.822897,
          lane: 0.336177
        }
      ],
      movingObstacles: [],
      boosters: [
        {
          id: "shield",
          s: 532.526588,
          lane: 0.640052,
          type: "shield"
        },
        {
          id: "speed",
          s: 1890.467338,
          lane: 0.459407,
          type: "speed"
        },
        {
          id: "speed_2",
          s: 3366.390095,
          lane: 0.519622,
          type: "speed"
        },
        {
          id: "shield_2",
          s: 4014.951411,
          lane: 0.300899,
          type: "shield"
        }
      ],
      sparks: [
        {
          id: "small",
          s: 1198.183819,
          lane: 0.479837
        },
        {
          id: "small_2",
          s: 2370.658692,
          lane: 0.541127
        },
        {
          id: "small_3",
          s: 3024.393772,
          lane: 0.326768
        },
        {
          id: "small_4",
          s: 4484.235168,
          lane: 0.375536
        }
      ]
    }
  ],
  willy: [
    {
      giantId: "willy",
      route: {
        viewBoxWidth: 6276,
        viewBoxHeight: 428,
        startPointSvgX: 64.270353,
        spawnSvgX: 82.633311,
        spawnSvgY: 219.062366,
        startLane: 0.488172,
        routeEndS: 5724.973535,
        finishCourierPlaceSvgX: 5794.390108,
        finishCourierPlaceSvgY: 219.062366,
        laneMin: 0.083871,
        laneMax: 0.745161
      },
      staticObstacles: [
        {
          id: "static",
          s: 299.219697,
          lane: 0.400267
        },
        {
          id: "static_2",
          s: 645.389919,
          lane: 0.808909
        },
        {
          id: "static_3",
          s: 918.148708,
          lane: 0.161729
        },
        {
          id: "static_5",
          s: 1190.838635,
          lane: 0.768181
        },
        {
          id: "static_4",
          s: 1375.850029,
          lane: 0.48419
        },
        {
          id: "static_6",
          s: 1870.727158,
          lane: 0.226245
        },
        {
          id: "static_8",
          s: 2249.215269,
          lane: 0.507866
        },
        {
          id: "static_7",
          s: 2498.281251,
          lane: 0.744525
        },
        {
          id: "static_9",
          s: 2874.27659,
          lane: 0.256213
        },
        {
          id: "static_11",
          s: 3093.176823,
          lane: 0.824196
        },
        {
          id: "static_12",
          s: 3494.320233,
          lane: 0.859474
        },
        {
          id: "static_10",
          s: 3526.951209,
          lane: 0.107455
        },
        {
          id: "static_13",
          s: 3889.7344,
          lane: 0.487536
        },
        {
          id: "static_14",
          s: 4427.897613,
          lane: 0.220935
        },
        {
          id: "static_19",
          s: 4736.721251,
          lane: 0.811192
        },
        {
          id: "static_15",
          s: 5035.11932,
          lane: 0.146676
        },
        {
          id: "static_16",
          s: 5164.669989,
          lane: 0.752464
        },
        {
          id: "static_18",
          s: 5324.840891,
          lane: 0.202119
        },
        {
          id: "static_17",
          s: 5434.513658,
          lane: 0.856535
        }
      ],
      movingObstacles: [],
      boosters: [
        {
          id: "shield",
          s: 428.752921,
          lane: 0.618402,
          type: "shield"
        },
        {
          id: "speed",
          s: 1663.225732,
          lane: 0.650977,
          type: "speed"
        },
        {
          id: "speed_2",
          s: 3190.564771,
          lane: 0.385385,
          type: "speed"
        },
        {
          id: "shield_2",
          s: 4606.344249,
          lane: 0.548826,
          type: "shield"
        }
      ],
      sparks: [
        {
          id: "small_2",
          s: 668.871552,
          lane: 0.330547
        },
        {
          id: "small_3",
          s: 1129.7818,
          lane: 0.331622
        },
        {
          id: "small",
          s: 2069.50618,
          lane: 0.403665
        },
        {
          id: "small_4",
          s: 2748.476555,
          lane: 0.615493
        },
        {
          id: "small_5",
          s: 4220.72672,
          lane: 0.487536
        },
        {
          id: "small_6",
          s: 5048.707909,
          lane: 0.487873
        }
      ]
    },
    {
      giantId: "willy",
      route: {
        viewBoxWidth: 6276,
        viewBoxHeight: 428,
        startPointSvgX: 64.270353,
        spawnSvgX: 82.633311,
        spawnSvgY: 219.062366,
        startLane: 0.488172,
        routeEndS: 5724.973535,
        finishCourierPlaceSvgX: 5794.390108,
        finishCourierPlaceSvgY: 219.062366,
        laneMin: 0.083871,
        laneMax: 0.745161
      },
      staticObstacles: [
        {
          id: "static",
          s: 311.253861,
          lane: 0.72517
        },
        {
          id: "static_2",
          s: 328.239597,
          lane: 0.201514
        },
        {
          id: "static_3",
          s: 924.116669,
          lane: 0.503665
        },
        {
          id: "static_5",
          s: 1384.567843,
          lane: 0.72517
        },
        {
          id: "static_4",
          s: 1393.290248,
          lane: 0.133772
        },
        {
          id: "static_6",
          s: 1870.727158,
          lane: 0.173557
        },
        {
          id: "static_8",
          s: 2018.548971,
          lane: 0.72517
        },
        {
          id: "static_7",
          s: 2481.754589,
          lane: 0.480009
        },
        {
          id: "static_9",
          s: 3022.543704,
          lane: 0.107966
        },
        {
          id: "static_11",
          s: 3093.176823,
          lane: 0.72517
        },
        {
          id: "static_12",
          s: 3494.320233,
          lane: 0.72517
        },
        {
          id: "static_10",
          s: 3526.951209,
          lane: 0.107455
        },
        {
          id: "static_13",
          s: 3889.7344,
          lane: 0.487536
        },
        {
          id: "static_14",
          s: 4570.53648,
          lane: 0.478934
        },
        {
          id: "static_15",
          s: 5035.11932,
          lane: 0.146676
        },
        {
          id: "static_16",
          s: 5164.669989,
          lane: 0.72517
        },
        {
          id: "static_18",
          s: 5324.840891,
          lane: 0.202119
        },
        {
          id: "static_17",
          s: 5434.513658,
          lane: 0.72517
        }
      ],
      movingObstacles: [],
      boosters: [
        {
          id: "shield",
          s: 1513.10855,
          lane: 0.46388,
          type: "shield"
        },
        {
          id: "speed",
          s: 3518.343573,
          lane: 0.499364,
          type: "speed"
        },
        {
          id: "shield_2",
          s: 4894.642691,
          lane: 0.478934,
          type: "shield"
        }
      ],
      sparks: [
        {
          id: "small_2",
          s: 620.209713,
          lane: 0.499364
        },
        {
          id: "small_3",
          s: 1129.7818,
          lane: 0.331622
        },
        {
          id: "small",
          s: 2069.50618,
          lane: 0.403665
        },
        {
          id: "small_4",
          s: 2937.615023,
          lane: 0.42302
        },
        {
          id: "small_5",
          s: 4220.72672,
          lane: 0.487536
        },
        {
          id: "small_6",
          s: 5364.275344,
          lane: 0.487536
        }
      ]
    },
    {
      giantId: "willy",
      route: {
        viewBoxWidth: 6276,
        viewBoxHeight: 428,
        startPointSvgX: 64.270353,
        spawnSvgX: 82.633311,
        spawnSvgY: 219.062366,
        startLane: 0.488172,
        routeEndS: 5724.973535,
        finishCourierPlaceSvgX: 5794.390108,
        finishCourierPlaceSvgY: 219.062366,
        laneMin: 0.084946,
        laneMax: 0.746237
      },
      staticObstacles: [
        {
          id: "static",
          s: 358.079404,
          lane: 0.259579
        },
        {
          id: "static_2",
          s: 662.90359,
          lane: 0.259579
        },
        {
          id: "static_3",
          s: 987.009801,
          lane: 0.685385
        },
        {
          id: "static_5",
          s: 1384.567843,
          lane: 0.726245
        },
        {
          id: "static_4",
          s: 1552.58891,
          lane: 0.192912
        },
        {
          id: "static_6",
          s: 1870.727158,
          lane: 0.173557
        },
        {
          id: "static_8",
          s: 2018.548971,
          lane: 0.726245
        },
        {
          id: "static_7",
          s: 2481.754589,
          lane: 0.480009
        },
        {
          id: "static_10",
          s: 3093.176823,
          lane: 0.726245
        },
        {
          id: "static_11",
          s: 3494.320233,
          lane: 0.726245
        },
        {
          id: "static_9",
          s: 3526.951209,
          lane: 0.107455
        },
        {
          id: "static_12",
          s: 3889.7344,
          lane: 0.487536
        },
        {
          id: "static_13",
          s: 4570.53648,
          lane: 0.478934
        },
        {
          id: "static_14",
          s: 5035.11932,
          lane: 0.146676
        },
        {
          id: "static_15",
          s: 5324.840891,
          lane: 0.202119
        }
      ],
      movingObstacles: [],
      boosters: [
        {
          id: "speed",
          s: 3518.343573,
          lane: 0.499364,
          type: "speed"
        },
        {
          id: "shield",
          s: 4894.642691,
          lane: 0.478934,
          type: "shield"
        }
      ],
      sparks: [
        {
          id: "small_2",
          s: 524.263257,
          lane: 0.685385
        },
        {
          id: "small_3",
          s: 1118.764025,
          lane: 0.193987
        },
        {
          id: "small",
          s: 2184.733742,
          lane: 0.462805
        },
        {
          id: "small_4",
          s: 2899.052811,
          lane: 0.478934
        },
        {
          id: "small_5",
          s: 4220.72672,
          lane: 0.487536
        },
        {
          id: "small_6",
          s: 5204.976682,
          lane: 0.726245
        }
      ]
    }
  ],
  yetti: [
    {
      giantId: "yetti",
      route: {
        viewBoxWidth: 6276,
        viewBoxHeight: 428,
        startPointSvgX: 64.270353,
        spawnSvgX: 72.805341,
        spawnSvgY: 208.873549,
        startLane: 0.511978,
        routeEndS: 5724.973535,
        finishCourierPlaceSvgX: 5794.389993,
        finishCourierPlaceSvgY: 208.873549,
        laneMin: 0.08172,
        laneMax: 0.743011
      },
      staticObstacles: [
        {
          id: "static",
          s: 644.999706,
          lane: 0.334911
        },
        {
          id: "static_2",
          s: 1142.176796,
          lane: 0.584888
        },
        {
          id: "static_3",
          s: 1613.108629,
          lane: 0.618402
        },
        {
          id: "static_4",
          s: 2291.886193,
          lane: 0.735584
        },
        {
          id: "static_5",
          s: 2716.800452,
          lane: 0.695126
        },
        {
          id: "static_6",
          s: 3610.158363,
          lane: 0.655341
        },
        {
          id: "static_9",
          s: 4471.573908,
          lane: 0.15743
        },
        {
          id: "static_7",
          s: 4838.314317,
          lane: 0.804203
        },
        {
          id: "static_8",
          s: 5280.63207,
          lane: 0.179185
        }
      ],
      movingObstacles: [],
      boosters: [
        {
          id: "shield",
          s: 1455.724306,
          lane: 0.334911,
          type: "shield"
        },
        {
          id: "shield_2",
          s: 3699.21871,
          lane: 0.308029,
          type: "shield"
        },
        {
          id: "shield_3",
          s: 4884.543064,
          lane: 0.268244,
          type: "shield"
        }
      ],
      sparks: [
        {
          id: "small",
          s: 932.38,
          lane: 0.425234
        },
        {
          id: "small_2",
          s: 2489.558846,
          lane: 0.374696
        },
        {
          id: "small_3",
          s: 3168.529221,
          lane: 0.408029
        },
        {
          id: "small_4",
          s: 4408.028892,
          lane: 0.541363
        }
      ]
    },
    {
      giantId: "yetti",
      route: {
        viewBoxWidth: 6276,
        viewBoxHeight: 428,
        startPointSvgX: 64.270353,
        spawnSvgX: 72.805341,
        spawnSvgY: 208.873549,
        startLane: 0.511978,
        routeEndS: 5724.973535,
        finishCourierPlaceSvgX: 5794.389993,
        finishCourierPlaceSvgY: 208.873549,
        laneMin: 0.07957,
        laneMax: 0.74086
      },
      staticObstacles: [
        {
          id: "static",
          s: 281.647723,
          lane: 0.424959
        },
        {
          id: "static_2",
          s: 710.908953,
          lane: 0.159195
        },
        {
          id: "static_3",
          s: 824.626162,
          lane: 0.833014
        },
        {
          id: "static_4",
          s: 1142.176796,
          lane: 0.584888
        },
        {
          id: "static_5",
          s: 1613.108629,
          lane: 0.618402
        },
        {
          id: "static_6",
          s: 2291.886193,
          lane: 0.735584
        },
        {
          id: "static_7",
          s: 2716.800452,
          lane: 0.695126
        },
        {
          id: "static_8",
          s: 3610.158363,
          lane: 0.655341
        },
        {
          id: "static_9",
          s: 4002.152429,
          lane: 0.248567
        },
        {
          id: "static_12",
          s: 4471.573908,
          lane: 0.15743
        },
        {
          id: "static_10",
          s: 4838.314317,
          lane: 0.804203
        },
        {
          id: "static_11",
          s: 5280.63207,
          lane: 0.179185
        }
      ],
      movingObstacles: [],
      boosters: [
        {
          id: "shield",
          s: 1455.724306,
          lane: 0.334911,
          type: "shield"
        },
        {
          id: "shield_2",
          s: 3699.21871,
          lane: 0.308029,
          type: "shield"
        },
        {
          id: "shield_3",
          s: 4884.543064,
          lane: 0.268244,
          type: "shield"
        }
      ],
      sparks: [
        {
          id: "small",
          s: 932.38,
          lane: 0.425234
        },
        {
          id: "small_2",
          s: 2489.558846,
          lane: 0.374696
        },
        {
          id: "small_3",
          s: 3168.529221,
          lane: 0.408029
        },
        {
          id: "small_4",
          s: 4408.028892,
          lane: 0.541363
        }
      ]
    },
    {
      giantId: "yetti",
      route: {
        viewBoxWidth: 6276,
        viewBoxHeight: 428,
        startPointSvgX: 64.270353,
        spawnSvgX: 72.805341,
        spawnSvgY: 208.873549,
        startLane: 0.511978,
        routeEndS: 5724.973535,
        finishCourierPlaceSvgX: 5794.389993,
        finishCourierPlaceSvgY: 208.873549,
        laneMin: 0.078495,
        laneMax: 0.739785
      },
      staticObstacles: [
        {
          id: "static",
          s: 281.647723,
          lane: 0.424959
        },
        {
          id: "static_2",
          s: 710.908953,
          lane: 0.159195
        },
        {
          id: "static_3",
          s: 824.626162,
          lane: 0.833014
        },
        {
          id: "static_4",
          s: 1142.176796,
          lane: 0.584888
        },
        {
          id: "static_5",
          s: 1388.240435,
          lane: 0.734911
        },
        {
          id: "static_6",
          s: 1613.108629,
          lane: 0.618402
        },
        {
          id: "static_8",
          s: 2016.253601,
          lane: 0.740287
        },
        {
          id: "static_7",
          s: 2291.886193,
          lane: 0.735584
        },
        {
          id: "static_9",
          s: 2716.800452,
          lane: 0.695126
        },
        {
          id: "static_10",
          s: 3005.81505,
          lane: 0.574305
        },
        {
          id: "static_12",
          s: 3336.922138,
          lane: 0.50904
        },
        {
          id: "static_11",
          s: 3506.871315,
          lane: 0.232103
        },
        {
          id: "static_13",
          s: 3701.165183,
          lane: 0.775392
        },
        {
          id: "static_14",
          s: 4002.152429,
          lane: 0.248567
        },
        {
          id: "static_15",
          s: 4151.26424,
          lane: 0.851241
        },
        {
          id: "static_20",
          s: 4471.573908,
          lane: 0.15743
        },
        {
          id: "static_16",
          s: 4838.314317,
          lane: 0.804203
        },
        {
          id: "static_19",
          s: 5104.669024,
          lane: 0.521386
        },
        {
          id: "static_17",
          s: 5280.63207,
          lane: 0.179185
        },
        {
          id: "static_18",
          s: 5533.444095,
          lane: 0.863588
        }
      ],
      movingObstacles: [],
      boosters: [
        {
          id: "shield",
          s: 1455.724306,
          lane: 0.334911,
          type: "shield"
        },
        {
          id: "shield_2",
          s: 2162.698192,
          lane: 0.46932,
          type: "shield"
        },
        {
          id: "shield_3",
          s: 3709.777411,
          lane: 0.46932,
          type: "shield"
        },
        {
          id: "shield_4",
          s: 4884.543064,
          lane: 0.268244,
          type: "shield"
        }
      ],
      sparks: [
        {
          id: "small",
          s: 476.519566,
          lane: 0.734911
        },
        {
          id: "small_2",
          s: 932.38,
          lane: 0.425234
        },
        {
          id: "small_3",
          s: 2516.309085,
          lane: 0.181538
        },
        {
          id: "small_4",
          s: 3168.529221,
          lane: 0.408029
        },
        {
          id: "small_5",
          s: 4408.028892,
          lane: 0.541363
        }
      ]
    }
  ]
};

export function getItemsLayoutForGiant(
  giantId: GiantId,
  orderIndex = 0,
): GiantItemsLayout {
  const variants = GIANT_ITEMS_LAYOUT[giantId];
  const index = Math.min(variants.length - 1, Math.max(0, Math.floor(orderIndex)));
  return variants[index];
}
